export default __webpack_public_path__ + "img/BB_RT.b81ef9d806fd82a9a364311f6e408e3f.jpg";